import type { ReactNode } from "react";

import { cn } from "#/lib/utils";

export function PageDescription({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return <p className={cn("text-sm leading-6 text-muted-foreground", className)}>{children}</p>;
}
